@import url("./datacom-card.css");

.dc-card-content {
  color: var(--dc-primary-text-color);
  flex-grow: 1;
}

.dc-card-image-wrapper {
  width: 100%;
}

.dc-action-icons {
  display: flex;
  justify-content: end;
}

.dc-action-icon {
  align-items: center;
  background-color: transparent;
  border: 1px solid var(--dc-primary-colour);
  border-radius: 13px;
  cursor: pointer;
  display: flex;
  height: 26px;
  justify-content: center;
  padding: 0;
  width: 26px;
}

.dc-action-icon-wrapper:not(:last-child) {
  margin-right: 8px;
}

.dc-stock-status {
  display: flex;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.002em;
  line-height: 17px;
  margin-bottom: 12px;
}

.dc-stock-status-icon {
  margin-right: 8px;
}

.dc-card-in-stock-icon path {
  fill: var(--dc-accent-status-color);
}
 
.dc-card-pre-order-icon path {
  fill: var(--dc-primary-status-color);
}

.dc-card-back-order-icon path {
 fill: var(--dc-secondary-status-color);
}

.dc-card-out-stock-icon path {
  fill: var(--dc-primary-error-color);
}

.dc-product-title {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: var(--dc-primary-text-color);
  display: -webkit-box;
  line-height: 24px;
  font-weight: 500;
  letter-spacing: -0.2px;
  margin-bottom: 16px;
  overflow: hidden;
  text-decoration: none;
}

.dc-price-wrapper {
  align-items: center;
  display: flex;
  margin-bottom: 16px;
}

.dc-price {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.005em;
  line-height: 29px;
}

.dc-previous-price {
  color: var(--dc-greyscale-03);
  letter-spacing: -0.002em;
  line-height: 20px;
  margin-left: 8px;
  text-decoration-line: line-through;
}
.dc-card-icon-shopping-cart path {
  stroke: var(--dc-primary-colour);
  fill: var(--dc-primary-colour);
}

.dc-card-icon-eye path, .dc-card-icon-exchange path {
  fill: var(--dc-primary-colour);
}

.dc-product-title:hover {
  color: var(--dc-primary-accent-colour);
}

.dc-product-title:focus {
outline: 2px solid var(--dc-primary-colour);
}

.dc-action-icon:hover {
  background-color: var(--dc-primary-colour);
}

.dc-action-icon:focus {
  outline: 1px solid var(--dc-primary-colour);
  outline-offset: 2px;
}

.dc-action-icon:hover .dc-card-icon-shopping-cart path {
  stroke: var(--dc-primary-token-text-color);
  fill: var(--dc-primary-token-text-color);
}

.dc-action-icon:hover .dc-card-icon-eye path, .dc-action-icon:hover .dc-card-icon-exchange path {
  fill: var(--dc-primary-token-text-color);
}